import * as React from 'react';

import styles from './index.scss';

interface IProps {
  handleShowLogin: () => void;
  history: any;
  show: boolean;
}

const Login: React.FunctionComponent<IProps> = ({
  handleShowLogin,
  history,
  show
}) => {
  const toggleLogin = () => {
    handleShowLogin();
    history.push('/blank/discard');
  };
  const scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  {
    return show ? (
      <div
        className={styles.loginModal}
        style={{ top: `calc(1.12rem - ${scrollTop}px)` }}
      >
        <div onClick={toggleLogin}>免费注册</div>
        <div onClick={toggleLogin}>登录</div>
      </div>
    ) : null;
  }
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/index.tsx